var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17.5C34 26.6127 26.6127 34 17.5 34C8.3873 34 1 26.6127 1 17.5C1 8.3873 8.3873 1 17.5 1C26.6127 1 34 8.3873 34 17.5Z",
    fill: "#392D69",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9777 17.5046C21.9788 17.3747 21.954 17.2459 21.9047 17.1257C21.8554 17.0055 21.7827 16.8964 21.6907 16.8046L15.6731 10.7916C15.5821 10.7006 15.474 10.6284 15.3551 10.5791C15.2362 10.5299 15.1088 10.5045 14.9801 10.5045C14.8514 10.5045 14.7239 10.5299 14.605 10.5791C14.4861 10.6284 14.3781 10.7006 14.2871 10.7916C14.1961 10.8826 14.1239 10.9906 14.0746 11.1095C14.0254 11.2284 14 11.3559 14 11.4846C14 11.6133 14.0254 11.7407 14.0746 11.8596C14.1239 11.9786 14.1961 12.0866 14.2871 12.1776L19.6117 17.5046L14.2871 22.8269C14.1961 22.9179 14.1239 23.026 14.0746 23.1449C14.0254 23.2638 14 23.3912 14 23.5199C14 23.6486 14.0254 23.7761 14.0746 23.895C14.1239 24.0139 14.1961 24.1219 14.2871 24.2129C14.3781 24.3039 14.4861 24.3761 14.605 24.4254C14.7239 24.4746 14.8514 24.5 14.9801 24.5C15.1088 24.5 15.2362 24.4746 15.3551 24.4254C15.474 24.3761 15.5821 24.3039 15.6731 24.2129L21.6907 18.1953C21.8742 18.0122 21.9774 17.7638 21.9777 17.5046V17.5046Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.05b9286aaf3be1d1d5705363f0270eba.svg";
export { ForwardRef as ReactComponent };